import AxiosDefault from "services/AxiosDefault";

export const CreateSpaceAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/settings/space/create",
    data,
  });
  return response;
};

export const GetSpaceAPI = async (placeId) => {
  const response = await AxiosDefault({
    method: "GET",
    url: `/settings/space/get/${placeId}`
  });
  return response;
};
export const DeleteSpaceAPI = async (data) => {
  const response = await AxiosDefault({
    method: "PATCH",
    url: "/settings/space/delete",
    data: data,
  });
  return response;
};

export const updateSpaceAPI = async ({placeId, ...rest}) => {
    const response = await AxiosDefault({
      method: "PUT",
      url: `/settings/space/update/${placeId}`,
      data: rest
    });
    return response; 
};
